export const TodayOccurrencesEnum = {
  FOLGA: 'Folga',
  PRESENTE: 'Presente',
  HORASFERIAS: 'Horas Férias',
  SEMMARCACAORECEBIDA: 'Sem Marcação Recebida',
  TURNONAOINICIADO: 'Turno Nao Iniciado',
  HORASATESTADO: 'Horas Atestado',
  HORASAFASTAMENTO: 'Horas Afastamento',
};
